import {post} from '../../request'

/**
 * 充值记录
 * @param data
 * @returns {Promise<*>}
 */
export function getRechargeOrder(data) {
    return post("/admin/rechargeorder/index", data)
}

